module.exports = __webpack_public_path__ + "static/media/hero-bottom.fbbeee9b.jpg";